import { render, staticRenderFns } from "./immersiveBanner.vue?vue&type=template&id=135cf1d9&scoped=true"
import script from "./immersiveBanner.vue?vue&type=script&lang=js"
export * from "./immersiveBanner.vue?vue&type=script&lang=js"
import style0 from "./immersiveBanner.vue?vue&type=style&index=0&id=135cf1d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135cf1d9",
  null
  
)

export default component.exports